import { Navigate, useLocation } from "react-router-dom";
import { LEGACY_ADMIN_REDIRECTS } from "../../config/adminSopConfig";

export default function OpsLegacyRedirect() {
  const { pathname, search } = useLocation();
  const target = LEGACY_ADMIN_REDIRECTS[pathname];
  if (!target) return <Navigate to="/admin" replace />;
  return <Navigate to={`${target}${search}`} replace />;
}
